import { useQuery } from "@tanstack/react-query"
import { getSalesLocations } from "@apis/salesLocations/salesLocations"
import { salesLocationsKeys } from "@apis/salesLocations/queryKeys"

export const useGetSalesLocationsQuery = (params?: { active?: boolean }) => {
  return useQuery({
    queryKey: salesLocationsKeys.list(params ?? {}),
    queryFn: () => getSalesLocations(params),
  })
}
